(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7623],{

/***/ 27623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ layouts_CatalogSeoPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./containers/index.js + 35 modules
var containers = __webpack_require__(44420);
// EXTERNAL MODULE: ./assets/icons/index.js + 78 modules
var icons = __webpack_require__(17499);
// EXTERNAL MODULE: ./hooks/index.js + 2 modules
var hooks = __webpack_require__(84431);
// EXTERNAL MODULE: ./layouts/CatalogSeoPage/CatalogSeoPage.module.scss
var CatalogSeoPage_module = __webpack_require__(79586);
var CatalogSeoPage_module_default = /*#__PURE__*/__webpack_require__.n(CatalogSeoPage_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./layouts/CatalogSeoPage/CatalogSeoPage.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CatalogSeoPage = function CatalogSeoPage(_ref) {
  var tree = _ref.tree;

  var _useWindowSize = (0,hooks/* useWindowSize */.iP)(),
      isMobile = _useWindowSize.isMobile;

  var _useState = (0,react.useState)({}),
      openedAll = _useState[0],
      setOpenedAll = _useState[1];

  var _useState2 = (0,react.useState)({}),
      openedHeadCategoty = _useState2[0],
      setOpenedHeadCategoty = _useState2[1];

  var getColor = function getColor(viewType, color) {
    if (viewType === 'sale') {
      return '#EA5656';
    }

    if (viewType === 'premium') {
      return '#74849C';
    }

    return color;
  };

  var allSectionsButton = (0,react.useCallback)(function (length, opened, id) {
    return length > 5 ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (CatalogSeoPage_module_default()).sectionButton,
        onClick: function onClick() {
          setOpenedAll(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, id, !opened));
          });
        },
        children: opened ? 'Свернуть разделы' : 'Все разделы'
      })
    }) : null;
  });
  var getBlockTitle = (0,react.useCallback)(function (_ref2, opened, length) {
    var color = _ref2.color,
        path = _ref2.path,
        name = _ref2.name,
        id = _ref2.id,
        view_type = _ref2.view_type;

    if (isMobile) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (CatalogSeoPage_module_default()).subCategoryTitle,
        style: {
          color: getColor(view_type, color)
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* RoutedLink */.S4, {
          to: path,
          children: name
        }), length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* default */.Z, {
          className: (CatalogSeoPage_module_default()).icon,
          name: opened ? 'arrow-up' : 'arrow-down',
          onClick: function onClick() {
            setOpenedHeadCategoty(function (prevState) {
              return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, id, !opened));
            });
          }
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (CatalogSeoPage_module_default()).subCategoryTitle,
      style: {
        color: getColor(view_type, color)
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RoutedLink */.S4, {
        to: path,
        children: name
      })
    });
  }, [isMobile]);
  var getBlock = (0,react.useCallback)(function (node) {
    var opened = typeof openedAll[node.id] === 'boolean' ? openedAll[node.id] : false;
    var openedCategoty = typeof openedHeadCategoty[node.id] === 'boolean' ? openedHeadCategoty[node.id] : false;
    var className = !openedCategoty ? (CatalogSeoPage_module_default()).mobileHidden : (CatalogSeoPage_module_default()).subCategoryBlock;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CatalogSeoPage_module_default()).block,
      children: [getBlockTitle(node, openedCategoty, node.children.length), node.children.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [node.children.map(function (_ref3, index) {
          var path = _ref3.path,
              name = _ref3.name,
              color = _ref3.color,
              id = _ref3.id,
              view_type = _ref3.view_type;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)((CatalogSeoPage_module_default()).subCategory, index > 4 && !opened && (CatalogSeoPage_module_default()).subCategoryHidden),
            style: {
              color: getColor(view_type, color)
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RoutedLink */.S4, {
              to: path,
              children: name
            })
          }, id);
        }), allSectionsButton(node.children.length, opened, node.id)]
      })]
    }, node.id);
  }, [openedAll, openedHeadCategoty, getBlockTitle, allSectionsButton]);
  var breadcrumbs = [{
    slug: '/',
    name: 'Каталог'
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CatalogSeoPage_module_default()).breadCrumbs,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
        breadcrumbs: breadcrumbs
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
      component: "h1",
      className: (CatalogSeoPage_module_default()).generalTitle,
      children: "\u041A\u0430\u0442\u0430\u043B\u043E\u0433"
    }), tree === null || tree === void 0 ? void 0 : tree.map(function (node) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (CatalogSeoPage_module_default()).container,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
          component: "h2",
          className: (CatalogSeoPage_module_default()).headCategory,
          style: {
            color: getColor(node.view_type, node.color)
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* RoutedLink */.S4, {
            to: node.path,
            children: node.name
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CatalogSeoPage_module_default()).wrapper,
          children: node.children.map(function (nodeCategory) {
            return getBlock(nodeCategory);
          })
        })]
      }, node.id);
    })]
  });
};

/* harmony default export */ var CatalogSeoPage_CatalogSeoPage = (CatalogSeoPage);
;// CONCATENATED MODULE: ./layouts/CatalogSeoPage/index.js

/* harmony default export */ var layouts_CatalogSeoPage = (CatalogSeoPage_CatalogSeoPage);

/***/ }),

/***/ 79586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"generalTitle":"CatalogSeoPage_generalTitle__qT2IM","container":"CatalogSeoPage_container__ZAiBD","headCategory":"CatalogSeoPage_headCategory__bOU7n","breadCrumbs":"CatalogSeoPage_breadCrumbs__wA_KJ","wrapper":"CatalogSeoPage_wrapper__v2RyP","block":"CatalogSeoPage_block__5DRrK","mobileHidden":"CatalogSeoPage_mobileHidden__KeImk","subCategory":"CatalogSeoPage_subCategory__DizUb","subCategoryTitle":"CatalogSeoPage_subCategoryTitle__ChiuX","icon":"CatalogSeoPage_icon__d4lVU","subCategoryBlock":"CatalogSeoPage_subCategoryBlock__c2fgv","subCategoryHidden":"CatalogSeoPage_subCategoryHidden__t7hut","sectionButton":"CatalogSeoPage_sectionButton__Tued7","load":"CatalogSeoPage_load__0UyGa"};

/***/ })

}]);